import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import {setItem,getItem} from "../utils/auth";

const token_key = 'kindergarten'
let store = new Vuex.Store({
    state:{
        user:getItem(token_key),
        orderId:''
    },
    mutations:{
        setUser (state,user){
            state.user = user
            setItem(token_key,state.user)
        },
        setId(state,id){
            state.orderId = id
        }
    },
    actions:{

    },
})
export default store

